import { datadogRum } from '@datadog/browser-rum'

import { Config } from '../config'

const isProduction = () => {
  const webpackDefineVars = Config.getVarsFromWebpackDefinePlugin()
  return webpackDefineVars.workspace === 'prod'
}

export const Datadog = {
  addError: (error: unknown, context?: object): void => {
    if (isProduction()) {
      return datadogRum.addError(error, context)
    }
  },
  addAction: (name: string, context?: object): void => {
    if (isProduction()) {
      return datadogRum.addAction(name, context)
    }
  },
}
